import React, {} from "react";
import { MdSave as Ico } from 'react-icons/md';
// Components
import CommonButton from "../../common/button/button";

const ButtonSave = ({ config }) => {

  let caption = "Guardar"
  let width = "120px";
  let marginLeft = "0px";
  let disabled = false;
  if (!!config) {
    if (config.visible === false) return null;
    caption = config.caption || caption;
    width = config.width || width;
    marginLeft = config.marginLeft || marginLeft;
    if (config.disabled) disabled = true
  }
  return (
    <CommonButton 
      onClick={() => {}} 
      style={{
        width,
        marginLeft,
        display: "flex", // Use flexbox to control alignment
        alignItems: "center", // Center icon and text vertically
        justifyContent: "flex-start", // Align icon and text to the left
        gap: "8px", // Add spacing between icon and text
      }}
      type={'submit'}
      disabled={disabled}
    >
      <Ico size={18} />
      <span>{caption}</span>
    </CommonButton>
  );
};

export default ButtonSave;
